// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IdcardTwoToneSvg from "@fishx/icons-svg/es/asn/IdcardTwoTone";
import FishxIcon from '../components/FishxIcon';

var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IdcardTwoToneSvg
  }));
};

IdcardTwoTone.displayName = 'IdcardTwoTone';
export default React.forwardRef(IdcardTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IdcardTwoTone.js
// module id = 2951
// module chunks = 0